"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.DMNTable = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var react_json_view_1 = __importDefault(require("react-json-view"));
var ui_components_1 = require("@codametrix/ui-components");
var ui_common_1 = require("@codametrix/ui-common");
var INPUT_COL_DEFS = [
    {
        key: 'key',
        displayName: 'Key',
        isSortable: false,
        defaultSort: 'none'
    },
    {
        key: 'value',
        displayName: 'Value',
        isSortable: false,
        defaultSort: 'none',
        transform: function (data) {
            var isJson = ui_common_1.objectUtils.isStringifiedJSON(data.value);
            var content = data.value;
            if (isJson) {
                content = ((0, jsx_runtime_1.jsx)(react_json_view_1["default"], { name: false, src: ui_common_1.objectUtils.getValueForString(data.value), displayObjectSize: false, collapsed: 1, displayDataTypes: false, enableClipboard: false, theme: 'rjv-default' }));
            }
            return content;
        }
    }
];
var OUTPUT_COL_DEFS = [
    {
        key: 'mappedKey',
        displayName: 'Key',
        isSortable: false,
        defaultSort: 'none'
    },
    {
        key: 'mappedValue',
        displayName: 'Value',
        isSortable: false,
        defaultSort: 'none',
        transform: function (data) {
            var isJson = ui_common_1.objectUtils.isStringifiedJSON(data.mappedValue);
            var content = data.mappedValue;
            if (isJson) {
                content = ((0, jsx_runtime_1.jsx)(react_json_view_1["default"], { name: false, src: ui_common_1.objectUtils.getValueForString(data.mappedValue), displayObjectSize: false, collapsed: 1, displayDataTypes: false, enableClipboard: false, theme: 'rjv-default' }));
            }
            return content;
        }
    }
];
var groupInputs = function (inputs) {
    return ui_common_1.objectUtils.groupBy(inputs, 'source');
};
var displayMatchedRule = function (rule) {
    if (!rule) {
        return false;
    }
    return rule.decisionRuleConditions.map(function (condition) {
        return ((0, jsx_runtime_1.jsx)("code", __assign({ className: "rule-condition" }, { children: condition.condition }), condition.conditionId));
    });
};
var displayInputs = function (inputs) {
    var groups = groupInputs(inputs);
    return Object.entries(groups).map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], values = _b[1];
        var table = ((0, jsx_runtime_1.jsx)(ui_components_1.DataGrid, { idField: "key", columnDefs: INPUT_COL_DEFS, items: values, selectable: false }));
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "input-table" }, { children: [(0, jsx_runtime_1.jsx)("h5", __assign({ className: "io-heading" }, { children: key })), " ", table] }), key));
    });
};
var displayOutputs = function (outputs, ruleMap) {
    var items = outputs.map(function (output) {
        return __assign(__assign({}, output), { id: "".concat(output.mappedKey, "-").concat(output.matchedDecisionRuleId) });
    });
    var matchedDecisions = ui_common_1.objectUtils.groupBy(items, 'matchedDecisionRuleId');
    return Object.entries(matchedDecisions).map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], values = _b[1];
        var table = ((0, jsx_runtime_1.jsx)("div", __assign({ className: "output-table" }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.DataGrid, { idField: "id", items: values, columnDefs: OUTPUT_COL_DEFS, selectable: false }) }), key));
        var rule = ruleMap.get(key);
        var matchedRules = displayMatchedRule(rule);
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "output-table" }, { children: [(0, jsx_runtime_1.jsx)("h5", __assign({ className: "io-heading" }, { children: key })), matchedRules, table] }), key));
    });
};
var buildDecisionRuleMap = function (decisionDTO) {
    var map = new Map();
    var decisionRules = decisionDTO.decisionRules;
    decisionRules.forEach(function (rule) {
        map.set(rule.ruleId, rule);
    });
    return map;
};
var DMNTable = function (props) {
    var step = props.step, spreadable = __rest(props, ["step"]);
    var decisions = step.decisions;
    var _a = __read((0, react_1.useState)({}), 2), openState = _a[0], setOpen = _a[1];
    var handleToggleClick = function (ev) {
        var _a, _b;
        console.log(ev);
        ev.stopPropagation();
        //@ts-ignore
        var key = (_b = (_a = ev.target) === null || _a === void 0 ? void 0 : _a.dataset.key) !== null && _b !== void 0 ? _b : '';
        var newOpenState = __assign({}, openState);
        newOpenState[key] = !openState[key];
        setOpen(newOpenState);
    };
    var items = decisions.map(function (decision) {
        // the decision key is not a unique enough id
        // we need to include executionTime as well.
        var key = "".concat(decision.decisionDefinitionDto.decisionKey, "-").concat(decision.executionTime);
        var ruleMap = buildDecisionRuleMap(decision.decisionDefinitionDto);
        var hasState = {
            inputs: decision.decisionInputs.length > 0,
            outputs: decision.decisionOutputs.length > 0
        };
        var outputKey = "".concat(key, "-output");
        var inputsKey = "".concat(key, "-inputs");
        var classes = (0, classnames_1["default"])({
            'has-io': hasState.inputs || hasState.outputs,
            'has-inputs': hasState.inputs,
            'has-outputs': hasState.outputs,
            'inputs-open': openState[inputsKey],
            'outputs-open': openState[outputKey]
        });
        var inputs = displayInputs(decision.decisionInputs);
        var outputs = displayOutputs(decision.decisionOutputs, ruleMap);
        return ((0, jsx_runtime_1.jsxs)("li", __assign({ className: classes }, { children: [decision.decisionDefinitionDto.decisionName, " ", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "io-toggles" }, { children: ["show:", (0, jsx_runtime_1.jsxs)("label", __assign({ className: "io-label outputs-label", htmlFor: outputKey, onClick: handleToggleClick }, { children: [(0, jsx_runtime_1.jsx)("input", { id: outputKey, "data-key": outputKey, type: "checkbox" }), ' ', (0, jsx_runtime_1.jsx)("span", __assign({ className: "inner-label" }, { children: "outputs" }))] })), (0, jsx_runtime_1.jsxs)("label", __assign({ className: "io-label inputs-label", htmlFor: inputsKey, onClick: handleToggleClick }, { children: [(0, jsx_runtime_1.jsx)("input", { id: inputsKey, "data-key": inputsKey, type: "checkbox" }), ' ', (0, jsx_runtime_1.jsx)("span", __assign({ className: "inner-label" }, { children: "inputs" }))] }))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "outputs-content" }, { children: [(0, jsx_runtime_1.jsx)("h4", __assign({ className: "data-type" }, { children: "Outputs" })), (0, jsx_runtime_1.jsx)("ul", { children: outputs })] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "inputs-content" }, { children: [(0, jsx_runtime_1.jsx)("h4", __assign({ className: "data-type" }, { children: "Inputs" })), (0, jsx_runtime_1.jsx)("ul", { children: inputs })] }))] }), decision.decisionDefinitionDto.decisionKey));
    });
    var classes = (0, classnames_1["default"])('dmn-table', {
        'no-items': items.length === 0
    });
    return ((0, jsx_runtime_1.jsx)("div", __assign({}, spreadable, { className: (0, classnames_1["default"])(classes) }, { children: (0, jsx_runtime_1.jsx)("ul", { children: items }) })));
};
exports.DMNTable = DMNTable;
DMNTable.displayName = 'DMNTable';
//# sourceMappingURL=dmn-table.js.map